import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
@Component({
  selector: 'app-modal-select',
  templateUrl: './modal-select.page.html',
  styleUrls: ['./modal-select.page.scss'],
})
export class ModalSelectPage implements OnInit {
    items = [];
    items2 = [];
    title = "Select";
    name = "";
    label = "";
    label2 = "";
    extended = false;
    freeinput = true;
    constructor(private modalController: ModalController) { }

  ngOnInit() {
  }

    close() {
        this.modalController.dismiss();
    }
    select(q,idx) {
        this.modalController.dismiss({value:q,idx:idx});
    }

}
